import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50c63a55"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "activity" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activity-header" }, null, -1))
const _hoisted_3 = { class: "activity-content" }
const _hoisted_4 = { class: "activity-content-goods groceries" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activity-content-goods-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/Client/activity/easter/tab.png",
    alt: ""
  })
], -1))
const _hoisted_6 = { class: "activity-goods-container" }
const _hoisted_7 = { class: "activity-goods bg-tab" }
const _hoisted_8 = {
  key: 1,
  class: "activity-empty"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/activity/christmas/empty.png",
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/activity/christmas/back.png",
  alt: ""
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]

import { t } from '@/plugins/i18n'
import { useSite, useSite2Station, isEN } from '@/store'
import GoodsItem from './components/Goods.vue'
import { onMounted, ref, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { searchProducts } from '@/apis/search'
import { productFavorite, productFavoriteCancel } from '@/apis/goods'
import { confirmLogin } from '@/util/useConfirm'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const loading1 = ref(false)
const loading2 = ref(false)
const isGro = ref(false)
const showBackup = ref(false)
let cloPageNum = 1
const cloFinish = ref(false)
const clothData = ref([])

const store = useStore()
// 服装
const CLOTH = 10
// 杂货
const GROCERY = 12
let groPageNum = 1
const groFinish = ref(false)
const groData = ref([])
const handleScroll = (e: any) => {
  if (e.target.scrollTop > 500 && !showBackup.value) {
    showBackup.value = true
  }
  if (e.target.scrollTop < 500 && showBackup.value) {
    showBackup.value = false
  }
  // console.log(e.target.scrollTop)
  const groEle = document.querySelector('.groceries')
  // console.log(groEle?.getBoundingClientRect().top)
  const topNum = groEle?.getBoundingClientRect().top || 1000
  if (topNum < 180 && !isGro.value) {
    isGro.value = true
  }
  if (topNum > 180 && isGro.value) {
    isGro.value = false
  }
}

const getList = (type: number) => {
  if (type === CLOTH) {
    loading1.value = true
  } else {
    loading2.value = true
  }
  searchProducts({
    pageSize: 50,
    pageNum: type === CLOTH ? cloPageNum : groPageNum,
    christmasTag: type,
    stationCode: useSite2Station()
    // abUser: false
  }).then((res) => {
    const { data } = res
    if (type === CLOTH) {
      cloFinish.value = data.records?.length === 0
      clothData.value = clothData.value.concat(data.records)
    } else {
      groFinish.value = data.records?.length === 0
      groData.value = groData.value.concat(data.records)
    }
  }).finally(() => {
    if (type === CLOTH) {
      loading1.value = false
    } else {
      loading2.value = false
    }
  })
}
const getMore = (type: number) => {
  if (type === CLOTH) {
    if (loading1.value) return
    cloPageNum++
  } else {
    if (loading2.value) return
    groPageNum++
  }
  getList(type)
}
onMounted(() => {
  if (!isEN()) {
    router.replace('/')
    return
  }
  getList(GROCERY)
  window.addEventListener('scroll', handleScroll, true)
})
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll, true)
})
const jump = (ele: string) => {
  const element: any = document.querySelector('.' + ele)
  const scrollTop = element?.offsetTop - (ele === 'cloth' ? 60 : 140)
  const scrollEle: any = document.querySelector('.el-scrollbar__wrap')
  scrollEle.scrollTop = scrollTop
}
const changeCollect = async (record: { productCode: string, favoriteFlag: number }) => {
  confirmLogin(async () => {
    const formData = {
      productCode: record.productCode
    }
    const api = record.favoriteFlag ? productFavoriteCancel : productFavorite
    await api(formData)

    !record.favoriteFlag && ElMessage.success(t('商品收藏成功'))
    record.favoriteFlag = record.favoriteFlag ? 0 : 1
  })
}

const checkLogin = (e:any) => {
  if (!store.getters.isLogin) {
    e.preventDefault()
    confirmLogin(() => {})
  }
}

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groData.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "activity-goods-item",
                key: index
              }, [
                _createVNode(GoodsItem, {
                  item: item,
                  index: index,
                  onChange: changeCollect
                }, null, 8, ["item", "index"])
              ]))
            }), 128)),
            ((!groFinish.value || groData.value.length < 500) && groData.value.length > 0)
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "activity-goods-btn btn-click",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (getMore(GROCERY)))
                }, [
                  _createTextVNode(_toDisplayString(_unref(t)('展开更多2')), 1)
                ], 512)), [
                  [_directive_loading, loading2.value]
                ])
              : _createCommentVNode("", true),
            (groData.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('没有搜索结果')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "backup flex-center",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (jump('activity')))
    }, _hoisted_11, 512), [
      [_vShow, showBackup.value]
    ])
  ]))
}
}

})